<template>
  <div>
    <!--整个单子售后原因设置  -->
    <el-dialog :title="$t('message.wholeListOfAftermarketReasonsSet')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="680px" center>
      <div class="content">
        <!-- 添加 -->
        <div class="row">
          <el-button type="success" size="small" @click="add" v-if="isAuth(332)">{{
            $t("message.add")
          }}</el-button>
        </div>

        <div class="table">
          <ol>
            <!-- ID -->
            <li>ID</li>
            <!-- 名义设置 -->
            <li class="flex2">
              {{ $t("message.causeSetting") }}
            </li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <!-- ID -->
            <li>{{ item.id }}</li>
            <!-- 名义设置 -->
            <li class="flex2">
              <el-input v-model="item.name" @blur="configReasonSet(item)"></el-input>
            </li>
            <!-- 操作 -->
            <li>
              <el-button type="success" size="small" class="dark" @click="configReasonDelete(item.id, index)"
                v-if="isAuth(333)">{{
                  $t("message.delete") }}</el-button>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    //列表
    configReasonList() {
      this.$api.capitalApi.configReasonList().then((res) => {
        this.tableData = res.data;
      });
    },
    //售后-调整原因-设置
    configReasonSet(item) {
      this.$api.capitalApi.configReasonSet(item).then((res) => {
        this.$message.success(res.msg);
        this.configReasonList();
      });
    },
    //新增
    add() {
      this.tableData.push({
        id: 0,
        name: "",
      });
    },
    //删除
    configReasonDelete(id, i) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          if (id == 0) {
            this.tableData.splice(i, 1);
          } else {
            this.$api.capitalApi.configReasonDelete({ id }).then((res) => {
              this.configReasonList();
              // 操作成功
              this.$message.success(res.msg);
            });
          }
        })
        .catch(() => { });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.configReasonList();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px 30px;

  .row {
    text-align: right;
    margin-bottom: 20px;
  }

  .table {
    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    .flex2 {
      flex: 4;
    }
  }

  /deep/.el-input {
    width: 80%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>